import * as React from "react";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import {passwordPattern} from "./passwordPattern";


interface IPasswordValidationComponentProps {
  password: string;
  setPassword: (e) => void;
  confirmationPassword: string;
  setConfirmationPassword: (e) => void;
  isValid: boolean;
  lowerCase: boolean;
  match: boolean;
  specialChar: boolean;
  upperCase: boolean;
  validLength: boolean;
  numericChar: boolean;
}

export const PasswordValidationComponent = (
  props: IPasswordValidationComponentProps
) => {
  const {
    password,
    setPassword,
    confirmationPassword,
    setConfirmationPassword,
    validLength,
    isValid,
    match,
    specialChar,
    upperCase,
    lowerCase,
    numericChar,
  } = props;



  return (
    <Row>
      <Col md={6}>
        <FormGroup noValidate>
          <Label>Password</Label>
          <Input
            className={isValid ? "valid" : ""}
            type="password"
            value={password}
            onChange={setPassword}
            pattern={passwordPattern}
          />
          <ul>
            <li>
              {validLength ? null : (
                <div>
                  <span className="text-danger">
                    Invalid: Minimum 10 characters.
                  </span>
                </div>
              )}
            </li>
            <li>
              {upperCase ? null : (
                <span className="text-danger">
                  Invalid: At least one uppercase.
                </span>
              )}
            </li>
            <li>
              {lowerCase ? null : (
                <span className="text-danger">
                  Invalid: At least one lowercase.
                </span>
              )}
            </li>
            <li>
              {numericChar ? null : (
                <span className="text-danger">
                  Invalid: At least one number.
                </span>
              )}
            </li>
            <li>
              {specialChar ? null : (
                <span className="text-danger">
                  Invalid: At least one special character (#?!@$%^&*-).
                </span>
              )}
            </li>
          </ul>
        </FormGroup>
      </Col>
      <Col md={6}>
        <FormGroup>
          <Label>Confirm Password</Label>
          <Input
            className={match ? "valid" : ""}
            type="password"
            value={confirmationPassword}
            onChange={setConfirmationPassword}
            pattern={passwordPattern}
          />
          <ul>
            <li>
              {match ? null : (
                <span className="text-danger">
                  Invalid: Passwords do not match.
                </span>
              )}
            </li>
          </ul>
        </FormGroup>
      </Col>
    </Row>
  );
};
